<p class="fw-bold">
  {{ 'user_edit_overview_l' | translate }}: {{ 'user_email_edit.form_l' | translate }}
</p>

<im-form-field class="mb-3">
  <label class="im:floating-label">
    <span floatingLabel>{{ 'user_email_edit.form_l' | translate }}</span>
    <input
      class="im:input"
      formControlName="email"
      id="email"
      type="email"
      [placeholder]="'user_email_edit.form_l' | translate"
    />
  </label>
</im-form-field>
<span>{{ 'user_email_edit.form_desc' | translate }}</span>
